import { FAIRY_KEYS } from "../constants/keys";

export const KEY_USAGE_STORAGE_KEY = "vocabularium_next_game_key";
export const KEY_USAGE_NONE = "none";
export const KEY_USAGE_CHANGE_EVENT = "keyUsagePreferenceChanged";

const VALID_KEY_IDS = new Set(FAIRY_KEYS.map((key) => key.id));

export function readKeyUsagePreference() {
  try {
    const raw = localStorage.getItem(KEY_USAGE_STORAGE_KEY);
    if (!raw || raw === KEY_USAGE_NONE) return null;
    if (VALID_KEY_IDS.has(raw)) return raw;
    return null;
  } catch {
    return null;
  }
}

export function writeKeyUsagePreference(keyId) {
  const value = keyId && VALID_KEY_IDS.has(keyId) ? keyId : KEY_USAGE_NONE;

  try {
    localStorage.setItem(KEY_USAGE_STORAGE_KEY, value);
  } catch {
    // ignore quota / privacy mode errors
  }

  window.dispatchEvent(
    new CustomEvent(KEY_USAGE_CHANGE_EVENT, {
      detail: { keyId: value === KEY_USAGE_NONE ? null : value },
    })
  );
}

export function subscribeKeyUsagePreference(onChange) {
  const handler = (event) => {
    onChange(event.detail?.keyId ?? readKeyUsagePreference());
  };

  window.addEventListener(KEY_USAGE_CHANGE_EVENT, handler);
  return () => window.removeEventListener(KEY_USAGE_CHANGE_EVENT, handler);
}
